<template>
  <article :id="$vnode.key">
    <custom-callout
      ref="callout"
      :has-toggle="true"
      :controlled="true"
      :opened="isOpen"
      class="mt-2 mb-3"
      @click:open="toggleCallout()"
    >
      <div class="container-fluid">
        <div class="row mx-auto align-items-center">
          <div class="col-6 col-md">
            <div class="info-text-title">Región:</div>
            <p class="info-text">
              {{ value.region.name }}
            </p>
          </div>
          <div class="col-6 col-md">
            <div class="info-text-title">Municipio:</div>
            <p class="info-text">
              {{ value.municipality.name }}
            </p>
          </div>
          <div class="col-6 col-md">
            <div class="info-text-title">Escuela:</div>
            <p class="info-text">
              {{ value.school.name }}
            </p>
          </div>
          <div class="col-6 col-md">
            <div class="info-text-title">Cantidad de Alternativas:</div>
            <p class="info-text">
              {{ value.numberOfAlternatives }}
            </p>
          </div>
          <div class="col-6 col-md">
            <div class="info-text-title">Resumen Cantidad de Estudiantes:</div>
            <p class="info-text">
              {{ value.studentsTotalResume }}
            </p>
          </div>
          <div
            class="col-12 col-md-2 px-0 mt-2 mt-md-0 d-md-flex justify-content-center"
          >
            <div class="align-self-center">
              <ActionButton
                text="Ver Alternativas"
                variant="outline-success"
                :responsive="true"
                i="fas fa-search"
                @click="toggleCallout"
              />
            </div>
          </div>
        </div>
      </div>
      <template #edition>
        <div class="additional-container">
          <div class="p2 mt-1">
            <div class="bg-gray p-2">
              <div class="bg-white p-3 rounded pl-c-xl">
                <span class="mt-1">
                  <i class="fa fa-info-circle mr-2 color-primary-2" />
                  <span class="title color-gray-7 font-weight-bold">
                    Detalle de las Alternativas
                  </span>
                </span>
                <custom-callout
                  v-for="item in collections.searchResult"
                  :key="item.id"
                  :has-toggle="false"
                  class="mt-3"
                >
                  <div class="row pt-2">
                    <div class="col-6 col-md">
                      <div class="info-text-title">
                        Categoría de la Alternativa:
                      </div>
                      <p class="info-text">
                        {{ item.id }} - {{ item.category.name }}
                      </p>
                    </div>
                    <div class="col-6 col-md">
                      <div class="info-text-title">
                        Nombre de la Alternativa:
                      </div>
                      <p class="info-text">
                        {{ item.alternative.name }}
                      </p>
                    </div>
                    <div class="col-6 col-md">
                      <div class="info-text-title">Grado(s):</div>
                      <p class="info-text">
                        <span
                          class="d-flex"
                          v-text="
                            item.grades.map((x) => x.name).join(', ') || '-'
                          "
                        />
                      </p>
                    </div>
                    <div class="col col-md">
                      <div class="info-text-title">Total de Estudiantes:</div>
                      <p class="info-text">
                        {{ item.numberOfStudents }}
                      </p>
                    </div>
                    <div class="col col-md">
                      <div class="info-text-title">Conteo Asistente:</div>
                      <p class="info-text">
                        {{ formatAssistantCount(item.numberOfAssistants) }}
                      </p>
                    </div>
                  </div>
                </custom-callout>
                <CustomResultNotFound
                  v-if="showNotResults"
                  class="mt-4 row pt-3"
                  text="No cuenta información disponible."
                />
                <div class="row pt-2">
                  <div class="col-12 pt-0">
                    <Pagination
                      v-if="pagination.totalItemCount > pagination.perPage"
                      :data="pagination"
                      :page-size="pagination.perPage"
                      :parent-id="$vnode.key"
                      @pagination-go-page="requestAdditionalInfo"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </custom-callout>
  </article>
</template>

<script>
import CustomCallout from "custom-callout";
import ActionButton from "ActionButton";
import Pagination from "pagination";
import CustomResultNotFound from "custom-result-not-found";
import { getSchoolAlternativeLocations } from "@/modules/alternative-location-management/api";

const DEFAULT_PAGE_SIZE = 5;

export default {
  name: "OtherSchoolEnrollmentResultRow",
  components: {
    CustomCallout,
    ActionButton,
    Pagination,
    CustomResultNotFound,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
      loaded: false,
      collections: {
        searchResult: [],
      },
      pagination: {
        perPage: DEFAULT_PAGE_SIZE,
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 0,
        count: 0,
      },
    };
  },
  computed: {
    showNotResults() {
      return this.collections.searchResult.length == 0 && this.loaded;
    },
  },
  methods: {
    async toggleCallout() {
      this.isOpen = !this.isOpen;
      if (!this.isOpen || this.loaded) return;
      await this.requestAdditionalInfo();
      this.loaded = this.isOpen;
    },
    async requestAdditionalInfo(page = 1) {
      this.pagination.currentPage = page;
      const mappedFilter = {
        academicYearId: this.value.academicYear?.id,
        schoolId: this.value.school?.id,
        pageIndex: page,
        pageSize: this.pagination.perPage,
      };

      const { data: result } = await getSchoolAlternativeLocations(mappedFilter);
      this.collections.searchResult = result.data;
      this.pagination = {
        ...this.pagination,
        totalItemCount: result.totalItemCount,
        pageCount: result.pageCount,
        currentPage: result.currentPage,
        count: result.count,
      };
    },
    formatAssistantCount(count) {
      return (count || 0).toString().padStart(2, "0");
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@import "@/assets/scss/variables/_colors.scss";

.info-text-title {
  color: map.get($colors, "gray-6");
  font-size: 1rem;
  font-weight: normal;
}

.info-text {
  color: map.get($colors, "black");
  font-weight: normal;
  font-size: 1rem;
  size: 1rem;
}
</style>
